// App.js
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import SnackBarComponent from "./Reducer/SnackBarReducer/SnackBarComponent";
import { ScreenChange } from "./Reducer/ScreenReducer/ScreenSlice";
import momentFR from "moment-locale-fr";
import moment from "moment";
import ApiHandler from "./Handler/ApiHandler";
import { AuthLogout } from "./Reducer/AuthReducer/AuthSlice";
import {
  getPathDefault,
  getRoutes,
  updateRouting,
} from "./Handler/RouteHandler";
import ScrollToTop from "./Component/ScrollToTop";
import Maintenance from "./Component/Maintenance";

//------ Dispatch --------//
export let dispatch;

//------ Moment --------//
moment.updateLocale("fr", momentFR);
moment.locale("fr");

function App() {
  dispatch = useDispatch();
  const [routes, setRoutes] = React.useState(false);
  const [routeDefault, setRouteDefault] = React.useState("");
  const [isReady, setReady] = React.useState(false);
  const [isMaintenance, setIsMaintenance] = React.useState(false);
  const authReducer = useSelector(
    (state) => state.AuthReducer
  );
  //---------- Screen --------------//
  const resize = () => {
    let screen = "";

    if (window.innerWidth < 576) screen = "XS";
    if (window.innerWidth >= 576 && window.innerWidth < 768) screen = "SM";
    if (window.innerWidth >= 768 && window.innerWidth < 992) screen = "MD";
    if (window.innerWidth >= 992 && window.innerWidth < 1200) screen = "LG";
    if (window.innerWidth >= 1200) screen = "XL";
    dispatch(
      ScreenChange({
        screen: screen,
        size: window.innerWidth,
        orientation:
          window.screen.orientation && window.screen.orientation.angle === 90,
      })
    );
  };
  React.useEffect(() => {
    window.addEventListener("resize", resize);
    window.addEventListener("orientationchange", resize);
    resize();

    return () => {
      window.removeEventListener("resize", resize);
      window.removeEventListener("orientationchange", resize);
    };
  }, []);

  // Security
  React.useEffect(() => {
    ApiHandler.get({ route: "default" }, (response) => {
      setIsMaintenance(Boolean(response?.data?.isMaintenance));

      if (!response.data.authenticated && authReducer.email) {
        dispatch(AuthLogout());
      }

      setReady(true);
    });
    setTimeout(() => window.location.reload(true), 21600000);
  }, [authReducer.email]);

  // Routing
  React.useEffect(() => {
    updateRouting(authReducer);
    setRoutes(getRoutes());
    setRouteDefault(getPathDefault());
  }, [authReducer]);

  if (!isReady) {
    return null;
  }

  if (isMaintenance) {
    return <Maintenance />;
  }

  if (routes) {
    return (
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          {Object.keys(routes).map((key) => {
            const route = routes[key];
            return (
              <Route
                key={"route_" + key}
                path={route.path}
                element={<route.layout view={route.view} />}
              />
            );
          })}
          <Route path="*" element={<Navigate to={routeDefault} replace />} />
        </Routes>
        <SnackBarComponent />
      </BrowserRouter>
    );
  }

  return null;
}

export default App;
